export default "__VITE_ASSET__D0jx4QrM__"